<template>
  <div>
    <header-status />
    <div class="conteudo">
      <div id="#videoLesson" class="video"></div>
      <div class="licao" v-if="lesson">
        <div class="video" v-if="!video">

          <vue-friendly-iframe
            :src="video_hoom"
            style="width: 800px; height: 455px;"
            allowfullscreen="allowfullscreen"
          ></vue-friendly-iframe>
        </div>

        <div class="footer-video">
          <p>{{lesson.name}}</p>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="exercicios">
              <h3>
                <img src="/assets/exercicios-gramaticos.png" />
              </h3>
              <slick ref="slick" :options="slickOptions" v-if="gramaticos.length">
                <div class="btn-q" v-for="(item, i) in gramaticos" :key="i">
                  <div class="btn-responder" @click="getQuestion(item.id)">
                    <div class="numero">{{i+1}}</div>
                    <div v-if="resposta(item.id) == 0">
                      <div class="status fazer">Fazer agora</div>
                    </div>
                    <div v-if="resposta(item.id) == 1">
                      <div class="status refazer">Refazer</div>
                    </div>

                    <div v-if="resposta(item.id) == 2">
                      <div class="status feito">Feito</div>
                    </div>
                  </div>
                </div>
              </slick>
            </div>
            <div class="exercicios">
              <h3>
                <img src="/assets/exercicios-foneticos.png" />
              </h3>
              <slick ref="slick" :options="slickOptions" v-if="foneticos.length">
                <div class="btn-q" v-for="(item, i) in foneticos" :key="i">
                  <div class="btn-responder" @click="getQuestion(item.id)">
                    <div class="numero">{{i+1}}</div>
                    <div v-if="resposta(item.id) == 0">
                      <div class="status fazer">Fazer agora</div>
                    </div>
                    <div v-if="resposta(item.id) == 1">
                      <div class="status refazer">Refazer</div>
                    </div>

                    <div v-if="resposta(item.id) == 2">
                      <div class="status feito">Feito</div>
                    </div>
                  </div>
                </div>
              </slick>
            </div>
          </div>
          <div class="col-6">
            <div class="resolucoes">
              <div v-if="question.type == 'fonetico' ">
                <div class="topo">
                  <div class="ordem">{{question.order}}</div>
                  <div class="text">
                    <div class="title">{{question.answer}}</div>
                    <div class="sub-tile">
                      Sua resposta:
                      <b>{{fala}}</b>
                    </div>
                  </div>
                </div>

                <div class="ouvir" @click="showSom()" v-if="!ouvir">
                  <a>
                    <v-icon>fas fa-volume-up</v-icon>
                    <br />Ouvir
                  </a>
                </div>
                <div class="audio" v-if="ouvir">
                  <audio :src="question.audio" preload="auto" controls></audio>
                </div>

                <div class="gravar" :class="{'blink': txt_gravar == 'Gravando'}" @click="start()">
                  <v-icon :class="{'blink': txt_gravar == 'Gravando'}">fas fa-microphone-alt</v-icon>
                  <br />
                  <span :class="{'blink': txt_gravar == 'Gravando'}">{{txt_gravar}}</span>
                </div>

                <div class="btn-next" @click="verificar(question.id,fala,question.answer)">Responder</div>
              </div>
              <div v-if="question.type == 'gramatico' ">
                <div v-if="question.sub_type == 'complete'">
                  <div class="topo">
                    <div class="ordem">{{question.order}}</div>
                    <div class="text">
                      <div class="title">{{question.title}}</div>
                    </div>
                  </div>

                  <h3>{{question.start}} (__) {{question.end}}</h3>

                  <v-text-field v-model="answer_complite" label="Digite a Resposta"></v-text-field>

                  <div
                    class="btn-next"
                    @click="verificar(question.id,answer_complite,question.answer)"
                  >Responder</div>
                </div>
                <div v-if="question.sub_type == 'alternativas'">
                  <div class="topo">
                    <div class="ordem">{{question.order}}</div>
                    <div class="text">
                      <div class="title">{{question.title}}</div>
                    </div>
                  </div>

                  <div class="radios">
                    <v-radio-group v-model="answer_alternativa" :mandatory="false">
                      <v-radio :label="question.a" value="A"></v-radio>
                      <v-radio :label="question.b" value="B"></v-radio>
                      <v-radio :label="question.c" value="C"></v-radio>
                    </v-radio-group>
                  </div>
                  <div class="btn-next" @click="verificar(question.id,answer_alternativa)">Responder</div>
                </div>
                <div v-if="question.sub_type == 'transforme'">
                  <div class="topo">
                    <div class="ordem">{{question.order}}</div>
                    <div class="text">
                      <div class="title">{{question.title}}</div>
                    </div>
                  </div>
                  <h3>{{question.phrase}}</h3>
                  <v-text-field
                    v-model="answer_transforme"
                    label="Digite a Resposta"
                    append-icon="fas fa-question"
                  ></v-text-field>
                  <div class="btn-next" @click="verificar(question.id,answer_transforme)">Responder</div>
                </div>

                <div v-if="question.sub_type == 'transforme_negativa'">
                  <div class="topo">
                    <div class="ordem">{{question.order}}</div>
                    <div class="text">
                      <div class="title">{{question.title}}</div>
                    </div>
                  </div>
                  <h3>{{question.phrase}}</h3>
                  <v-text-field v-model="answer_transforme_negativa" label="Digite a Resposta"></v-text-field>
                  <div
                    class="btn-next"
                    @click="verificar(question.id,answer_transforme_negativa)"
                  >Responder</div>
                </div>

                <div v-if="question.sub_type == 'associativa'">
                  <div class="topo">
                    <div class="ordem">{{question.order}}</div>
                    <div class="text">
                      <div class="title">{{question.title}}</div>
                    </div>
                  </div>

                  <p>A) {{question.a}}</p>
                  <p>B) {{question.b}}</p>
                  <p>C) {{question.c}}</p>
                  <p>D) {{question.d}}</p>

                  <div v-for="(it, index) in associatives" :key="index">
                    <v-text-field v-model="it.value" :label="it.text"></v-text-field>
                  </div>
                  <div
                    class="btn-next"
                    @click="verificarAssociativo(question.id,associatives,question.answer)"
                  >Responder</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer-page />

    <v-dialog v-model="dialogResp" width="400px">
      <v-card>
        <v-card-title style="text-align: center;">
          <span class="headline" v-if="status == 'hit'">PARABÉNS VOCÊ ACERTOU!</span>
          <span class="headline" v-else>RESPOSTA INCORRETA!</span>
        </v-card-title>
        <v-card-text style="text-align: center;">
          <v-icon color="green" size="80" v-if="status == 'hit'">fas fa-check-circle</v-icon>
          <v-icon color="red" size="80" v-else>fas fa-times-circle</v-icon>
          <div v-if="status == 'hit' && question.translate">
            TRADUÇÃO
            <br />
            {{question.translate}}
          </div>

          <div v-if="status == 'missed'">
            <v-btn color="primary" text @click="showAnswer = true">VER RESPOSTA</v-btn>
            <br />
            <div v-if="showAnswer">{{question.answer}}</div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogResp = false; showAnswer = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { authService } from "../plugins/firebase";
import Slick from "vue-slick";

export default {
  components: { Slick },

  data() {
    return {
      dialogResp: false,
      showAnswer: false,
      video_hoom: null,
      txt_gravar: "Gravar",
      video: null,
      ouvir: null,
      user_max_module: 0,
      user_max_lesson: 0,
      user_id: 0,
      lesson: null,
      respostas: [],
      module: 0,
      lesson_id: 0,
      question: {},
      mediaRecorder: "",
      recognition: "",
      noteContent: "",
      fala: "",
      answer_complite: "",
      answer_alternativa: "",
      answer_transforme: "",
      answer_associativa: "",
      answer_transforme_negativa: "",
      associatives: [],
      gramaticos: {},
      foneticos: {},
      status: null,
      slickOptions: {
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 2,
        nextArrow: '<img src="http://hoomweb.com/img/next.png" class="next">',
        prevArrow: '<img src="http://hoomweb.com/img/prev.png" class="prev">'
      }
    };
  },
  created() {
    this.module = this.$route.params.module;
    this.lesson_id = this.$route.params.id;
    this.getLesson();
    this.reInit();
  },
  methods: {
    videoUrl() {
      return (
        "https://embed.videodelivery.net/embed/r4xu.fla9.latest.js?video=" +
        this.lesson.video_id
      );
    },
    showSom() {
      this.ouvir = true;
      return true;
    },
    showVideo() {
      this.video = true;
      return true;
    },
    resposta(id) {
      var status = 0;
      this.respostas.forEach(obj => {
        if (id == obj.question_id) {
          if (obj.status == "missed") {
            status = 1;
          } else {
            status = 2;
          }
        }
      });
      return status;
    },
    getQuestion(id) {
      this.lesson.questions.forEach(obj => {
        if (id == obj.id) {
          this.question = obj;

          this.associatives = [
            { text: obj.a_answer, alt: "A" },
            { text: obj.b_answer, alt: "B" },
            { text: obj.c_answer, alt: "C" },
            { text: obj.d_answer, alt: "D" }
          ];
          this.associatives = this.embaralhar(this.associatives);

          console.log("Associatives", this.associatives);

          this.answer_alternativa = "";
          this.answer_complite = "";
          this.answer_transforme = "";
          this.answer_associativa = "";
          this.answer_transforme_negativa = "";
          this.ouvir = null;
          this.fala = "";
        }
      });
      return true;
    },
    async getLesson() {
      let config = {
        headers: {
          Authorization: "Bearer " + (await authService.validToken())
        }
      };
      this.$http.get(SERVE + "/students/modules", config).then(response => {
        var data = response.data;
        const arr = [];
        const gramaticos = [];
        const foneticos = [];

        response.data.forEach(obj => {
          if (obj.id == this.module) {
            // this.lesson = obj.lessons.find(o=>o.id==this.lesson_id);
            // this.gramaticos =  this.lesson.questions.filter(o=>o.tye == "gramatico");
            // this.foneticos =  this.lesson.questions.filter(o=>o.tye == "gramatico");
            obj.lessons.forEach(ij => {
              if (ij.id == this.lesson_id) {
                ij.questions.forEach(qst => {
                  if (qst.type == "gramatico") {
                    gramaticos.push(qst);
                  }
                  if (qst.type == "fonetico") {
                    foneticos.push(qst);
                  }
                });
                arr.push(ij);
              }
            });
          }
        });
        this.gramaticos = gramaticos;
        this.foneticos = foneticos;
        this.lesson = arr[0];
        this.video_hoom = `https://profkenny.com.br/stream/${this.lesson.video_id}`;
      });
      this.$http
        .get(
          this.$SERVE +
            "/students/me?device_id=" +
            DeviceUUID.get() +
            "&device_name=" +
            DeviceUUID.parse().browser +
            "&platform=web",
          config
        )
        .then(response => {
          this.user_max_module = response.data.course.module.order;
          this.user_max_lesson = response.data.course.unlocked;
          this.user_id = response.data.id;

          this.getRespostas();
        })
        .catch();
    },

    async getRespostas() {
      let config = {
        headers: {
          Authorization: "Bearer " + (await authService.validToken())
        }
      };
      this.$http.get(SERVE + "/students/myactivities", config).then(objs => {
        this.respostas = objs.data;

        //console.log("ACTIVITES", objs.data);
      });
    },
    start() {
      this.txt_gravar = "Gravando";
      var SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition;
      this.recognition = new SpeechRecognition();
      this.fala = "";

      this.recognition.lang = "en-US";
      this.recognition.onresult = event => {
        var current = event.resultIndex;

        var transcript = event.results[current][0].transcript;

        var mobileRepeatBug =
          current == 1 && transcript == event.results[0][0].transcript;

        if (!mobileRepeatBug) {
          this.fala += transcript;
          if (this.fala) {
            this.txt_gravar = "Gravar";
          }
        }
      };
      this.recognition.start();
    },
    verificarAssociativo(question_id, answer, check) {
      var status = "missed";
      var resp = "";
      answer[0].value = answer[0].value.toUpperCase();
      answer[1].value = answer[1].value.toUpperCase();
      answer[2].value = answer[2].value.toUpperCase();
      answer[3].value = answer[3].value.toUpperCase();

      if (
        answer[0].value == answer[0].alt &&
        answer[1].value == answer[1].alt &&
        answer[2].value == answer[2].alt &&
        answer[3].value == answer[3].alt
      ) {
        status = "hit";
        //alert("Resposta Certa !!!");
      } else {
        status = "missed";
        //alert("Resposta Errada !!!");
      }

      this.status = status;
      this.dialogResp = true;
      answer.forEach(obj => {
        resp += obj.text + "," + obj.value + ";";
      });

      this.responder(question_id, resp, status);
    },
    verificar(question_id, answer) {
      if (!answer || answer.trim() == "") return alert("Responda a Questão");
      var status = "missed";
      //answer = answer.toUpperCase();
      console.log(
        answer,
        this.question.answer,
        this.normalizeText(answer),
        this.normalizeText(this.question.answer)
      );
      const resp = [
        this.normalizeText(this.question.answer),
        this.normalizeText(this.question.a || ""),
        this.normalizeText(this.question.b || ""),
        this.normalizeText(this.question.c || "")
      ];

      if (resp.includes(this.normalizeText(answer))) {
        status = "hit";
        //alert("Resposta Certa !!!");
      } else {
        //alert("Resposta Errada !!!");
      }

      this.status = status;
      this.dialogResp = true;

      this.responder(question_id, answer, status);
    },
    async responder(question_id, answer, status) {
      const params = {
        id: this.user_id,
        module_id: this.lesson.module_id,
        lesson_id: this.lesson.id,
        question_id: question_id,
        status: status,
        answer: answer
      };

      let config = {
        headers: {
          Authorization: "Bearer " + (await authService.validToken())
        }
      };
      this.$http
        .post(SERVE + "/students/activities", params, config)
        .then(response => {
          this.getRespostas();
        });
    },
    embaralhar(array) {
      var indice_atual = array.length,
        valor_temporario,
        indice_aleatorio;

      while (0 !== indice_atual) {
        indice_aleatorio = Math.floor(Math.random() * indice_atual);
        indice_atual -= 1;

        valor_temporario = array[indice_atual];
        array[indice_atual] = array[indice_aleatorio];
        array[indice_aleatorio] = valor_temporario;
      }

      return array;
    },
    normalizeText(t) {
      t = t.normalize("NFD");
      t = t.replace(/\s\s+/g, " ");
      t = t.replace(/[0-9/,?!.:' ` ‘ ’]/g, "");
      t = t.toLowerCase();
      return t;
    },
    next() {
      this.$refs.slick.next();
    },
    prev() {
      this.$refs.slick.prev();
    },

    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        //if($)
        //$(this.$el)[0].slick("refresh");
      });
    },

    // Events listeners
    handleAfterChange(event, slick, currentSlide) {
      console.log("handleAfterChange", event, slick, currentSlide);
    },
    handleBeforeChange(event, slick, currentSlide, nextSlide) {
      console.log("handleBeforeChange", event, slick, currentSlide, nextSlide);
    },
    handleBreakpoint(event, slick, breakpoint) {
      console.log("handleBreakpoint", event, slick, breakpoint);
    },
    handleDestroy(event, slick) {
      console.log("handleDestroy", event, slick);
    },
    handleEdge(event, slick, direction) {
      console.log("handleEdge", event, slick, direction);
    },
    handleInit(event, slick) {
      console.log("handleInit", event, slick);
    },
    handleReInit(event, slick) {
      console.log("handleReInit", event, slick);
    },
    handleSetPosition(event, slick) {
      console.log("handleSetPosition", event, slick);
    },
    handleSwipe(event, slick, direction) {
      console.log("handleSwipe", event, slick, direction);
    },
    handleLazyLoaded(event, slick, image, imageSource) {
      console.log("handleLazyLoaded", event, slick, image, imageSource);
    },
    handleLazeLoadError(event, slick, image, imageSource) {
      console.log("handleLazeLoadError", event, slick, image, imageSource);
    }
  }
};
</script>
<style>
</style>
